<template>
  <div class="arnergy-table">
    <vue-good-table
      @on-select-all="selectAll"
      @on-row-click="toggleSelectRow"
      :columns="columns"
      :rows="rows"
      :select-options="selectOption"
      :search-options="searchOption"
    >
      <template slot="table-row" slot-scope="props" style="background: red">
        <div>
          <span v-if="props.column.field == 'name'">
            {{
              props.row["installation"]["name"]
                ? props.row["installation"]["name"]
                : "---"
            }}
          </span>
          <span v-if="props.column.field == 'deviceId'">{{
            props.row["DeviceID"] ? props.row["DeviceID"] : "---"
          }}</span>
          <span v-if="props.column.field == 'fault'">{{
            props.row["Fault"] ? props.row["Fault"] : "---"
          }}</span>
          <span
            v-if="props.column.field == 'severity'"
            :class="
              props.row['Severity'] == 'minor'
                ? 'badge badge-info'
                : 'badge badge-warning'
            "
            >{{ props.row["Severity"] ? props.row["Severity"] : "--" }}</span
          >
          <span
            v-if="props.column.field == 'status'"
            :class="
              props.row['Status'] == 'resolved'
                ? 'statusLabel badge badge-success'
                : 'statusLabel badge badge-danger'
            "
            >{{ props.row["Status"] ? props.row["Status"] : "--" }}</span
          >
          <span v-if="props.column.field == 'date'">{{
            props.row["StartTime"] ? props.row["StartTime"] : "--"
          }}</span>

          <!-- <span v-if="props.column.field == 'action'">
              <b-button
                style="background-color:#1a93ca; color:white; border: none"
                type="primary"
                @click="viewStatus(props.row)"
              >View</b-button>
            </span>-->
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
export default {
  name: "arnergy-table",
  props: {
    columns: {
      type: Array,
      //   default: () => []
      //   required: true
    },
    rows: {
      type: Array,
      //   default: () => []
      //   required: true
    },
    searchOption: {
      type: Object,
      default: () => {
        enabled: true;
      },
      //   required: true
    },
    selectOption: {
      type: Object,
      default: () => {
        enabled: true;
      },
      //   required: true
    },
    pageChanged: {
      type: Function,
      default: () => Function,
    },
    selectAll: {
      type: Function,
      default: () => Function,
    },
    toggleSelectRow: {
      type: Function,
      default: () => Function,
    },
    perPageChanged: {
      type: Function,
      default: () => Function,
    },
  },
  mounted() {},
};
</script>

<style>
.widget_box {
  min-height: auto !important;
}

.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}

/* .vgt-left-align,
.vgt-right-align {
    text-align: center !important;
}

.vgt-left-align:first-child {
    color: #323c47;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.15px;
} */

.vgt-table thead th {
  background: #ffffff !important;
}

table th,
table th span {
  font-size: 13px;
  font-weight: 500 !important;
  letter-spacing: 0.13px;
  color: #334d6e;
  opacity: 0.6;
  text-transform: none !important;
}

.vgt-table tbody .clickable th {
  background: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/arnergy-table.vue